// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__aE7kl","brandName":"NavBar_brandName__K12fv","link":"NavBar_link__u2LLj","searchBarDiv":"NavBar_searchBarDiv__hrOoS"};